import {initCopione, initGame, nextInjections, renderEvent} from "./backstageHelperFunctions.mjs";
import TextLabel from "../../Controls/TextLabel.mjs";

const G = window.glob;

const getReal = ( df )=> {
	if ( df?.id ) return df.real;
	if ( typeof G.getStatus('gameIsReal') === 'boolean') return G.getStatus('gameIsReal');
	if ( G.getStatus('Game')?.id ) return G.getStatus('Game').real;
	if ( G.getStatus('Scenario')?.id ) return G.getStatus('Scenario').real;
	return false;
}

const backstageHelper = class {
    constructor( copione, game ) {
        this.state = {};
        this.setCopione(copione || G.getStatus('Copione'), getReal(game ));
        this.setGame( game || G.getStatus('Game') );
        if (  G.getStatus('Player')?.admin?.gameMaster ) {
            this.state.gm = true;
        }
    }
    canPause() {
        return (this.getStatus() === 'running' && this.state.game?.timerStarted);
    }
    getStatus() {
        return this.state.game?.status;
    }
    getLastupdate() {
        return this.state.game?.lastupdate;
    }
    nextInjection() {
		// console.log( 'COPIONE', JSON.stringify(this.state.copione) );
		// console.log( 'GAME',JSON.stringify(this.state.game) );
		// console.log( 'NEXT', nextInjections( this.state.copione, this.state.game ) );
        return nextInjections( this.state.copione, this.state.game );
    }
    renderHistory() {
        if ( ! this.state.game?.event ) return '';
        return this.state.game.event.map( (e,idx) => renderEvent(
            e,
            {
                index: idx,
                game: this.state.game,
                copione: this.state.copione
            }
        ));
    }
    renderTimer() {
        const s = this.state.game?.status;
        if ( ! s ) return '';
        if ( s === 'pending' ) return <TextLabel value={"GameNotStarted"} />

    }
    setCopione(c, isReal) {
        return this.state.copione = initCopione(c || G.getStatus('Copione'), isReal ?? G.getStatus('Game')?.real);
    }
    setGame(g) {
        return this.state.game = initGame( g || G.getStatus('Game'));
    }
};

export default backstageHelper;
